<template>
  <div class="coupon-container">
    <img v-if="available" src="@/assets/1111-default.png" @click="showPayHandle">
    <img v-else src="@/assets/1111-success.png" @click="$router.push({path: '/my'})">
    <button v-if="!isEffective">{{ message }}</button>
    <button v-else-if="available" @click="showPayHandle">速去抢购</button>
    <button v-else class="isReceive" @click="$router.push({path: '/my'})">已购买,快去看看吧</button>
    <popup v-model="showPayInfo">
      <div class="popup-content">
        <!-- <div class="popup-desc">支付{{ album.cost | money }}元</div> -->
        <template v-if="!isWxWeb">
        <div>
          <label for="wechat" class="popup-item">
            <img src="@/assets/icon_wechat.png">
            <span style="flex:1">微信支付</span>
            <input id="wechat" type="radio" name="paytype" value="1" v-model="payMethod">
          </label>
        </div>
        <div>
          <label for="alipay" class="popup-item">
            <img src="@/assets/icon_alipay.png">
            <span style="flex:1">支付宝支付</span>
            <input id="alipay" type="radio" name="paytype" value="0" v-model="payMethod">
          </label>
        </div>
        </template>
        <template v-else>
          <div>
            <label for="wechat" class="popup-item">
              <img src="@/assets/icon_wechat.png">
              <span style="flex:1">微信支付</span>
              <input id="wechat" type="radio" name="paytype" value="2" v-model="payMethod">
            </label>
          </div>
        </template>
        <button @click="tpay">确认支付</button>
      </div>
    </popup>
  </div>
</template>

<script>
import { Popup, Toast } from 'mint-ui';
import { umtrack } from '@/utils/uweb'
import { coupon, receiveCounpon } from '@/api/coupon'
import { pay, ready } from '@/api/pay'
import { paying } from '@/utils/pay'
import { isWeiXin, analogJump } from '@/utils/index'
export default {
  name: 'Index',
  components: {
    Popup
  },
  data () {
    return {
      code: 0,
      available: true,
      info: {},
      payMethod: 1,
      showPayInfo: false,
      isEffective: true,
      message: '',
      isWxWeb: false,
      defaultMethod: 1,

      ispaying: false,
      timer: null,
    }
  },
  created () {
    this.isWxWeb = isWeiXin()
    this.payReady()
    var query = this.$route.query
    this.code = query.code
    this.init()
    umtrack('couponview', {code: this.code, title: '优惠劵'}, this)
    if(this.isWxWeb){
      this.defaultMethod = 2
    }
    this.payMethod = this.defaultMethod
  },
  mounted() {
    window.addEventListener('pageshow', (e)=>{
      if(e.persisted){
        console.log('to cache load')
        window.location.reload()
      }
    })
  },
  methods: {
    payReady() {
      if(!this.isWxWeb){
        return
      }
      ready({method: 2, redirect: window.location.href}).catch(error=>{
        window.location.replace(error.data)
      })
    },
    init() {
      this.isEffective = true
      coupon({code: this.code}).then((response)=>{
        this.info = response.data.data
        this.available = this.info.available
      }).catch((err)=>{
        this.isEffective = false
        var code = parseInt(err.code)
        switch (code) {
          case 402:
            this.message = '活动即将开始'
            break;
          default:
            this.message = '活动已结束'
            break;
        }
      })
    },
    showPayHandle() {
      umtrack('coupon-pay', {id: this.info.id, title: this.info.title}, this)
      if(Number(this.info.isfree) !== 0){
        return this.showPayInfo = true
      }
      receiveCounpon({code: this.code}).then((response)=>{
        this.available = false
        this.$nextTick(()=>{
            this.$router.push({path: '/my'})
        })
      }).catch(err=>{
        this.isEffective = false
        switch (parseInt(err.message)) {
          case 402:
            this.message = '活动即将开始'
            break;
          case 404:
            this.message = '没有该活动'
            break;
          case 401:
            this.message = '劵抢光了'
            break;
          case 405:
            this.message = '很抱歉不符合要求'
            break;
          case 310:
            this.$router.push({path: '/login', query: { scene: 'login', redirect: this.$route.fullPath}})
            break;
          case 311:
            this.$router.push({path: '/login', query: { scene: 'bind', redirect: this.$route.fullPath}})
            break;
          default:
            this.message = '活动已结束'
            break;
        }
      })
    },
    tpay(){
      if(this.ispaying) {
        Toast({
          message: "正在支付请稍后",
          position: 'bottom',
          duration: 1000
        })
        return
      }
      this.ispaying = true
      this.clearStatus()
      const params = {
        price: this.info.price,
        title: this.info.title,
        source: this.info.id,
        sign: this.info.sign,
        method: this.payMethod,
        type: 2
      }
      pay(params).then((response)=>{
        this.showPayInfo = false
        var data = response.data.data
        paying(this.payMethod, data.url, data.return_url).then( url => {
          analogJump(url, '', false)
        })
      }).catch((error)=>{
        this.showPayInfo = false
        if(error.message != 'Error'){
          this.$router.push({path: '/login', query: { scene: error.message==311?'bind':'login', redirect: this.$route.fullPath}})
        }
      })
    },
    clearStatus(){
      if(this.timer){
        window.clearTimeout(this.timer)
      }
      this.timer = window.setTimeout(() => {
        this.ispaying = false;
      },5000);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.coupon-container{
    &>img{
        width: 100%;
        display:block
    }
    &>button{
        border:none;
        background: linear-gradient(45deg,#FFBC4A, #FF8724);
        color: #fff;
        font-size: 19px;
        position: fixed;
        bottom: 0;
        right: 50%;
        width: 94vw;
        margin-right: -47vw;
        margin-bottom: 16px;
        padding: 10px 0;
        border-radius: 3px;
        outline: none;
    }
    &>button.isReceive{
      color: #fff;
      border: none;
    }
    .popup-content{
    padding: 16px;
    width: 70vw;
    text-align: left;
    .popup-desc{
      font-size: 19px;
    }
    .popup-item{
      display: flex;
      align-items: center;
      padding: 6px 0;
      border-bottom: #eee solid 1px;
      margin: 10px 0;
      font-size: 18px;
      img{
        width: 19px;
        margin-right: 6px;
      }
    }
    button{
      border: none;
      background-color: rgb(245, 121, 19);
      width: 100%;
      color: #eee;
      border-radius: 6px;
      padding: 10px;
      font-size: 16px;
      margin-top: 13px;
    }
  }
}
@media screen and (max-height: 532px) {
  .coupon-container{
    &>button{
      font-size: 19px;
      margin-bottom: 10px;
      padding: 6px 0;
      border-radius: 13px;
      outline: none;
    }
  }
}
</style>
